@if (error$ | async; as error) {
  <div class="error-banner">
    <div class="icon-content-wrapper">
      <span class="error-icon"></span>
      <div class="error-content">
        <strong>{{ error.title }}</strong>
        <p>{{ error.message }}</p>
      </div>
    </div>
    @if (error.btnTitle) {
      <button class="btn-primary-md" (click)="dismiss()">
        {{error.btnTitle}}
      </button>
    }
  </div>
}